"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { pageview } from "@/lib/analytics";

/**
 * Envoie une page vue à chaque changement de route.
 *
 * Le routeur de Next change d'URL sans recharger la page : la capture
 * automatique de PostHog ne verrait que la première, et tout le parcours
 * serait perdu. On la coupe à l'init et on envoie d'ici.
 *
 * ⚠️ On lit `window.location.href` plutôt que `useSearchParams()`. Ce hook
 * force la page qui l'utilise à sortir du rendu statique, et ce composant est
 * monté dans le gabarit commun : il aurait rendu TOUT le site dynamique, pour
 * une chaîne de caractères qu'on peut lire directement. `usePathname` suffit
 * à déclencher, `href` donne l'URL entière, paramètres compris.
 *
 * Monté seulement quand la personne a accepté, donc jamais avant.
 */
export function MesureDesPages() {
  const chemin = usePathname();

  useEffect(() => {
    if (typeof window === "undefined") return;
    pageview(window.location.href);
  }, [chemin]);

  return null;
}
